import { Flex, Image } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router";

import { EppoFeatureFlags } from "app/types/flags";
import { routes } from "config/routes";
import ScanImage from "images/inbound/inbound-index-page-scan.png";
import { useEppoFeatureFlagProvider } from "shared/hooks/useEppoFeatureFlag";
import { BOTTOM_TAB_BAR_HEIGHT_NUMBER } from "ui/BottomTabBarContainer";
import { Button } from "ui/Button/Button";
import { BodyM, HeaderS } from "ui/Typography/Typography";

export function RolliScanPlaceholder() {
  const navigate = useNavigate();

  const { isFeatureEnabled: isTransportEquipmentFlowEnabled } = useEppoFeatureFlagProvider(
    EppoFeatureFlags.ENABLE_TRANSPORT_EQUIPMENT_FLOW,
  );
  const handleNavigateToTransportEquipmentFlow = () => {
    navigate(routes.activities.deliveryCheckIn.transportEquipmentConfirm);
  };
  return (
    <Flex
      flex={1}
      direction="column"
      h="100%"
      w="100%"
      pb={`${BOTTOM_TAB_BAR_HEIGHT_NUMBER}px`}
      alignItems="center"
      justifyContent="center"
      bg="white"
      data-testid="rolli-scan-placeholder"
      borderRadius="0 0 8px 8px"
    >
      <Flex maxW="296px" minH="272px" flexDirection="column" alignItems="center">
        <HeaderS mb="s100">
          <FormattedMessage id="components.rolli-scan-placeholder.title" />
        </HeaderS>
        <BodyM textAlign="center" color="grey.800" mb="s300">
          <FormattedMessage id="components.rolli-scan-placeholder.subtitle" />
        </BodyM>
        <Image src={ScanImage} h="124px" w="124px" mb="s500" />
        {isTransportEquipmentFlowEnabled && (
          <Button
            variant="link"
            size="sm"
            color="pinkFlink.500"
            onClick={handleNavigateToTransportEquipmentFlow}
          >
            <FormattedMessage id="components.rolli-scan-placeholder.cta" />
          </Button>
        )}
      </Flex>
    </Flex>
  );
}
